import { nanoid } from 'nanoid'
import { useEffect, useState } from 'react'
import { useStEditorStore } from '../stores/st-editor.store'

const DEFAULT_CONTENT = [
    {
        type: 'para',
        children: [{ text: 'lets begin story' }],
        id: nanoid(),
    },
]

export const useStoryEditor = (defaultContent = DEFAULT_CONTENT) => {
    const [jsonScript, setJsonScript] = useState<any[] | undefined>(undefined)
    const { storyEntity } = useStEditorStore()

    useEffect(() => {
        const fetchData = async () => {
            if (storyEntity != undefined) {

                const saved = storyEntity!.content ?? []

                try {
                    if (saved && saved.length !== 0) {
                        if (Array.isArray(saved)) {
                            setJsonScript(saved)
                        } else {
                            throw 'saved content is not in proper format'
                        }
                    } else {
                        throw 'empty content'
                    }
                } catch (error) {
                    setJsonScript(defaultContent)
                }
            }
        }
        fetchData()
    }, [storyEntity, defaultContent])

    return { jsonScript, storyEntity }
}
